"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * This is a [React](https://reactjs.org/) component for the navigation panel in the Vanilla
 * [Application Layout](https://vanillaframework.io/docs/layouts/application).
 *
 * This component is used to display the left navigation panel. It should be
 * used alongside [`AppNavigationBar`](/docs/components-applicationlayout-appnavigationbar--docs).
 */
const AppNavigation = _ref => {
  let {
    children,
    className,
    collapsed,
    pinned,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("header", _extends({
    className: (0, _classnames.default)("l-navigation", className, {
      "is-collapsed": collapsed,
      "is-pinned": pinned
    })
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "l-navigation__drawer"
  }, children));
};
var _default = exports.default = AppNavigation;